import { combineReducers } from "redux";
import DeviceReducer from "./devices/reducer";
import articles from "./reducers/articles";
import auth from "./reducers/auth";
import graph from "./reducers/graph";

const rootReducer = combineReducers({
  DeviceReducer,
  auth,
  graph,
  articles,
});

export default rootReducer;
